import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { ENTERPRISE_USERS_QUERY_KEY } from 'hooks/queries/enterprise';
import { ORGANIZATION_INVITATIONS_QUERY_KEY } from 'hooks/queries/organization';
import { InvitationQuery } from 'types/organization';

type UseInviteOrganizationMutation = UseMutationResult<
  unknown,
  unknown,
  InvitationQuery['members']
>;

export const useInviteOrganizationMutation = (
  orgId?: string
): UseInviteOrganizationMutation => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      apiClient.user.createInvitation(
        {
          body: { members: payload },
        },
        orgId ? { headers: overrideOrganizationHeader(orgId) } : undefined
      ),
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ORGANIZATION_INVITATIONS_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ENTERPRISE_USERS_QUERY_KEY],
      });
    },
  });
};
